// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:08:18+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            63a0b729648db05c21789f0753a8f51d
//    Signature:      eyJpdiI6IlZHMUZZUE5WQ1E4OFNURUpoZ0NzOXc9PSIsInZhbHVlIjoieWhFSGtCRTZkNUp6Y1wvaElQTHRQdnZoTXhpMjFiaXQzQlhmM1NOeTZlWVwvRWJEMXJGUFJLN2FzQzZ4SlZDTHdvSFpoQnNKaVNuVjZxMWRPYmxFNjc1U3ZEcHlyQTBHVlwvcWtmUzdpd3FQQlwvYm93OU0wY2tydU9hZTFjS2lseVEyMmEyR2dldG16UDNwMHpjWWlvMHFscmVGcm5Sb0xGYU42NXJuSGtFa21xUEFKekRxSjZ5MFBJRHE2UzE4OWxZa2YrdUNxQWxib0JUOWt2TTYxd01xV3hCUnlBNzhsZEFlTHFTT3JCckdIenZxR0FOZEhHTm5BeFBjb0ZBMjI4N05YTm5RVzhPZ1hBWTF6THRaQU0wQWRPeG81VHRxNVYwMFA5WGRLbmlEaFh1YmxHa1RTd0V0alNRZFBQTTgwdmxwYit1RHZyNUFkUkhmWWFvUXNkUWxPcERVRnJDd2lwdWVOdzJKMExNMzM5bHBOcUE1S1FWQ0VwbkVkYmVGa3Q5NzhOcE1EMFFPXC85MmpXbWRYODdNbU13PT0iLCJtYWMiOiJmNmVhMTMzMjNlYWJjNDE2OWMxNDgyNTQxMzNjZWI2MWY5ZDYxYzYxMWZmNzYxZjMyNTYyYmU2M2EyN2VmOTllIn0=
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
